import { InputLog } from "@scrile/api-provider/dist/api/LogProvider";
import { LoggerContext } from "@scrile/streaming-client/build/Logger";
import providers from "@/lib/api";
import { IS_BROWSER } from "@/lib/browserUtils";
import { Logger } from "@/modules/logger";

export type RequiredLoggerContext = Pick<InputLog, "streaming"> & LoggerContext;

export type LoggerContextWithMessage = LoggerContext & { message: string };
export interface ICallLogger {
  collectLogs: (
    message: string,
    requiredContext: RequiredLoggerContext,
    context: LoggerContext & { message: string }
  ) => Promise<void>;
}

export class CallsLogger extends Logger implements ICallLogger {
  public async collectLogs(message: InputLog["message"], context: RequiredLoggerContext): Promise<void> {
    this.debug(message, context);
    const { streaming, error = null, ...otherContext } = context;

    const { stackTrace, updatedError } = CallsLogger.separateError(error);

    await providers.LogProvider.log({
      data: {
        message,
        streaming,
        userAgent: CallsLogger.userAgent,
        stackTrace,
        body: { ...otherContext, error: updatedError },
      },
    });
  }

  private static separateError(error?: Error) {
    let stackTrace = undefined;
    let updatedError = undefined;
    if (error) {
      const { name, message, stack = "" } = error;
      stack && (stackTrace = stack);
      updatedError = { name, message };
    }

    return { stackTrace, updatedError };
  }

  private static get userAgent(): string {
    if (IS_BROWSER) return window.navigator.userAgent;
    return "Request of 'userAgent' was called in not browser environment";
  }
}

export default new CallsLogger();
